import { get } from 'lodash';
import PropTypes from 'prop-types';

import { GET_JOYBIRD_INSTAGRAM_IMAGES } from 'mocks/queries';
import useSuspenseQuery from 'commons/useSuspenseQuery';

const InstagramImages = ({ render }) => {
  const { data, error, loading } = useSuspenseQuery(
    GET_JOYBIRD_INSTAGRAM_IMAGES
  );

  if (loading || !data) return null;

  if (error) return `Error!: ${error}`;

  return render({
    config: {
      images: get(data, 'getJoybirdInstagramImages.images', []),
    },
  });
};

InstagramImages.propTypes = {
  render: PropTypes.func.isRequired,
};

export default InstagramImages;
